var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPause = function SvgPause(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 7a1.5 1.5 0 1 0-3 0v10a1.5 1.5 0 0 0 3 0V7Zm6 0a1.5 1.5 0 0 0-3 0v10a1.5 1.5 0 0 0 3 0V7Z",
    fill: "currentColor"
  })));
};

export { SvgPause as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIj4KPHBhdGggeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTEwLjUgN0MxMC41IDYuMTcxNTcgOS44Mjg0MyA1LjUgOSA1LjVDOC4xNzE1NyA1LjUgNy41IDYuMTcxNTcgNy41IDdWMTdDNy41IDE3LjgyODQgOC4xNzE1NyAxOC41IDkgMTguNUM5LjgyODQzIDE4LjUgMTAuNSAxNy44Mjg0IDEwLjUgMTdWN1pNMTYuNSA3QzE2LjUgNi4xNzE1NyAxNS44Mjg0IDUuNSAxNSA1LjVDMTQuMTcxNiA1LjUgMTMuNSA2LjE3MTU3IDEzLjUgN1YxN0MxMy41IDE3LjgyODQgMTQuMTcxNiAxOC41IDE1IDE4LjVDMTUuODI4NCAxOC41IDE2LjUgMTcuODI4NCAxNi41IDE3VjdaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz48L3N2Zz4K";